export default "__VITE_PUBLIC_ASSET__9a540044__"